import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectItineraryChange = (state) => state.get('itineraryChange');

const makeSelectItineraryChange = () => createSelector(
  selectItineraryChange,
  (selectItineraryChangeState) => ({

    // Itinerary Change
    itineraryChange: mapWithDefault(
      selectItineraryChangeState,
      () => selectItineraryChangeState.getIn(['form', 'itineraryChange']),
      ''
    ),

    detailsRegardingYourTripDelay: mapWithDefault(
      selectItineraryChangeState,
      () => selectItineraryChangeState.getIn(['form', 'detailsRegardingYourTripDelay']),
      ''
    ),

    dateDelayEndedForDelay: mapWithDefault(
      selectItineraryChangeState,
      () => selectItineraryChangeState.getIn(['form', 'dateDelayEndedForDelay']),
      ''
    ),

    dateTripWasDelayedWithTravelSupplier: mapWithDefault(
      selectItineraryChangeState,
      () => selectItineraryChangeState.getIn(['form', 'dateTripWasDelayedWithTravelSupplier']),
      ''
    ),
    dateYouWereNotifiedOfChangeByCruiseLine: mapWithDefault(
      selectItineraryChangeState,
      () => selectItineraryChangeState.getIn(['form', 'dateYouWereNotifiedOfChangeByCruiseLine']),
      ''
    ),
    datesChangedByCruiseLine: mapWithDefault(
      selectItineraryChangeState,
      () => selectItineraryChangeState.getIn(['form', 'datesChangedByCruiseLine']),
      ''
    ),
    dateDelayEnded: mapWithDefault(
      selectItineraryChangeState,
      () => selectItineraryChangeState.getIn(['form', 'dateDelayEnded']),
      ''
    ),
    descriptionOfReasonForChangeInItinerary: mapWithDefault(
      selectItineraryChangeState,
      () => selectItineraryChangeState.getIn(['form', 'descriptionOfReasonForChangeInItinerary']),
      ''
    ),

    companyNameForOther: mapWithDefault(
      selectItineraryChangeState,
      () => selectItineraryChangeState.getIn(['form', 'companyNameForOther']),
      ''
    ),
    addressForOther: mapWithDefault(
      selectItineraryChangeState,
      () => selectItineraryChangeState.getIn(['form', 'addressForOther']),
      ''
    ),
    typeOfPolicyForOther: mapWithDefault(
      selectItineraryChangeState,
      () => selectItineraryChangeState.getIn(['form', 'typeOfPolicyForOther']),
      ''
    ),
    policyForOther: mapWithDefault(
      selectItineraryChangeState,
      () => selectItineraryChangeState.getIn(['form', 'policyForOther']),
      ''
    ),
    contactForOther: mapWithDefault(
      selectItineraryChangeState,
      () => selectItineraryChangeState.getIn(['form', 'contactForOther']),
      ''
    ),
    phoneForOther: mapWithDefault(
      selectItineraryChangeState,
      () => selectItineraryChangeState.getIn(['form', 'phoneForOther']),
      ''
    ),

    cityOrTownForOther: mapWithDefault(
      selectItineraryChangeState,
      () => selectItineraryChangeState.getIn(['form', 'cityOrTownForOther']),
      ''
    ),

    countryForOther: mapWithDefault(
      selectItineraryChangeState,
      () => selectItineraryChangeState.getIn(['form', 'countryForOther']),
      ''
    ),

    postalCodeForOther: mapWithDefault(
      selectItineraryChangeState,
      () => selectItineraryChangeState.getIn(['form', 'postalCodeForOther']),
      ''
    ),

    companyNameLoss: mapWithDefault(selectItineraryChangeState, () => selectItineraryChangeState.getIn(['form', 'companyNameLoss']), ''),
    amountPaidLoss: mapWithDefault(selectItineraryChangeState, () => selectItineraryChangeState.getIn(['form', 'amountPaidLoss']), ''),
    currentAmountPaidLoss: mapWithDefault(selectItineraryChangeState, () => selectItineraryChangeState.getIn(['form', 'currentAmountPaidLoss']), ''),
    amountOfLoss: mapWithDefault(selectItineraryChangeState, () => selectItineraryChangeState.getIn(['form', 'amountOfLoss']), ''),
    currentAmountOfLoss: mapWithDefault(selectItineraryChangeState, () => selectItineraryChangeState.getIn(['form', 'currentAmountOfLoss']), ''),
    haveYouReceivedReimbursement: mapWithDefault(selectItineraryChangeState, () => selectItineraryChangeState.getIn(['form', 'haveYouReceivedReimbursement']), ''),
    howMuchReceivedReimbursement: mapWithDefault(selectItineraryChangeState, () => selectItineraryChangeState.getIn(['form', 'howMuchReceivedReimbursement']), ''),
    currentReceivedReimbursement: mapWithDefault(selectItineraryChangeState, () => selectItineraryChangeState.getIn(['form', 'currentReceivedReimbursement']), ''),
    fromWhomReceivedReimbursement: mapWithDefault(selectItineraryChangeState, () => selectItineraryChangeState.getIn(['form', 'fromWhomReceivedReimbursement']), ''),
    dateReimbursementReceived: mapWithDefault(selectItineraryChangeState, () => selectItineraryChangeState.getIn(['form', 'dateReimbursementReceived']), ''),
    enableTime: mapWithDefault(selectItineraryChangeState, () => selectItineraryChangeState.getIn(['form', 'enableTime']), null),
    lossInformationItems: mapWithDefault(selectItineraryChangeState, () => selectItineraryChangeState.getIn(['form', 'lossInformationItems']) && selectItineraryChangeState.getIn(['form', 'lossInformationItems']).toJS(), ''),
  })
);

const makeSelectItineraryChangeErrors = () =>
  createSelector(selectItineraryChange, (state) => state.get('errors'));

export {
  makeSelectItineraryChange,
  makeSelectItineraryChangeErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.ItineraryChange/selectors.js